import AutomotiveScheduleModal from "./AutomotiveScheduleModal";

/** Vehicle Market unified grid — production schedule modal. */
const VehicleMarketScheduleModal = (props) => <AutomotiveScheduleModal {...props} />;

export default VehicleMarketScheduleModal;
